import "./polyfills.js"
import "core-js/es6/map"
import "core-js/es6/set"
import "array-flat-polyfill"
import React from "react"
import ReactDOM from "react-dom"
import Favicon from "react-favicon"
import "../semantic/dist/semantic.min.css"
import App from "./App"
import favicon from "./assets/favicon.ico"
import "./sentry.js"

export default App

if (typeof document !== "undefined") {
  const renderMethod = module.hot
    ? ReactDOM.render
    : ReactDOM.hydrate || ReactDOM.render
  const render = Comp => {
    renderMethod(
      <React.Fragment>
        <Favicon url={favicon} />

        <Comp />
      </React.Fragment>,
      document.getElementById("root")
    )
  }

  // Render!
  render(App)
}



// WEBPACK FOOTER //
// /opt/build/repo/src/index.js